import React from "react";

export default function HomebackBannerDesktop({ activeCard, cards }) {
  if (!cards || !cards.length) return null;

  return (
    <div className="absolute inset-0 hidden lg:block">
      {cards.map((card, index) => (
        <div
          key={card.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            activeCard === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={card.img}
            alt={card.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-slate-950/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-slate-950/60" />
    </div>
  );
}